import { React, useEffect, useState } from 'react';
import PageHeader from 'utility/PageHeader';
import PageBody from 'utility/PageBody';
import { Button, Form, Input, Row, Col, Table, DatePicker } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { HttpHandler } from '../../shared/httpHandler';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

const Recommend = () => {
  const httpHandler = new HttpHandler();

  const [searchForm] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
    },
  });

  // 更新表格資料
  const updateData = (pagination = tableParams.pagination) => {
    const { name, sales } = searchForm.getFieldsValue();
    const { current, pageSize } = pagination;
    setLoading(true);
    httpHandler
      .get(
        `/line-official-mgmt/recommend?name=${name}&sales=${sales}&page=${current}&page_size=${pageSize}`
      )
      .then((response) => {
        if (response.success) {
          setTableData(response.data);
          setTableParams({
            ...tableParams,
            pagination: {
              ...pagination,
              total: response.total,
            },
          });
        } else {
          window.antdNotify('錯誤', response.data.message, 'fail');
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // Table 分頁、排序、篩選更動時觸發
  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      ...sorter,
    });
    updateData(pagination);
  };

  // 搜尋表單送出
  const onFinish = async () => {
    setTableParams({
      ...tableParams,
      pagination: {
        current: 1,
        pageSize: 10,
      },
    });
    updateData({
      current: 1,
      pageSize: 10,
    });
  };

  const SearchBar = () => {
    return (
      <>
        <Form form={searchForm} name="searchForm" onFinish={onFinish}>
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item label="客戶姓名" name="name">
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="推薦業代姓名" name="sales">
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={16} className="button-group">
              <Button
                type="primary"
                icon={<SearchOutlined />}
                htmlType="submit"
                className="button button--search">
                搜尋
              </Button>
            </Col>
          </Row>
        </Form>
      </>
    );
  };

  const DataTable = (props) => {
    let columns = [
      {
        title: '客戶姓名',
        dataIndex: 'name',
        render: (text, record) => {
          if (text) return text;
          else return '使用者未綁定';
        },
      },
      // 隱藏欄位
      // {
      //   title: '區域業代',
      //   dataIndex: 'a_name',
      // },
      // {
      //   title: '負責業代',
      //   dataIndex: 'p_name',
      // },
      // {
      //   title: '服務專員',
      //   dataIndex: 's_name',
      // },
      {
        title: '推薦業務',
        dataIndex: 'r_name',
      },
      {
        title: '業代推薦加入時間',
        dataIndex: 'r_create_time',
      },
    ].filter((item) => !item.hidden);

    return (
      <>
        <Table
          columns={columns}
          rowKey={(_, index) => index}
          dataSource={props.tableData}
          pagination={tableParams.pagination}
          loading={loading}
          bordered="true"
          scroll={{ x: 'max-content' }}
          onChange={handleTableChange}
        />
      </>
    );
  };

  useEffect(() => {
    // 預設表單值
    searchForm.setFieldsValue({
      name: '',
      sales: '',
    });
    // 進入畫面時執行一次搜尋
    onFinish();
  }, []);

  DataTable.propTypes = {
    tableData: PropTypes.array,
  };

  const section = [
    {
      hasTitle: false,
      title: 'Search',
      children: <SearchBar />,
    },
    {
      hasTitle: false,
      title: 'Data',
      children: <DataTable tableData={tableData} />,
    },
  ];

  return (
    <div>
      <PageHeader functionName={'recommend'}></PageHeader>
      <PageBody section={section}></PageBody>
    </div>
  );
};

export default Recommend;
